import { configureStore } from "@reduxjs/toolkit"

import userReducer from "src/store/user"
import messagesReducer from "src/store/messages"
import lobbyReducer from "src/store/lobby"
import gameReducer from "src/store/game"
import commonReducer from "src/store/common"
import uiReducer from "src/store/ui"
import economyReducer from "src/store/economy"

export default configureStore({
  reducer: {
    user: userReducer,
    messages: messagesReducer,
    lobby: lobbyReducer,
    game: gameReducer,
    common: commonReducer,
    ui: uiReducer,
    economy: economyReducer,
  },
})
